import { component } from 'picoapp';
import Accordion from 'utils/accordion';

export default component((node) => {
  Accordion(node);
});
